import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './ManualEntry.scss';

import ManualEntryStageOptions from './ManualEntryStageOptions';
import {
  PATH_MANUAL,
  STEP_EVERIFY,
  STEP_LANDING,
  STEP_BANK_FAILURE,
  STEP_BANK_SUCCESS,
} from '../AddBank/AddBank';
import Checkbox from '../../../components/Shared/Checkbox/Checkbox';
import RadioButton from '../../../components/Shared/RadioButton/RadioButton';
import { getIsEnteredBankLapsed } from '../../../redux/modules/eVerification/eVerification.selectors';
import settings, { TOLL_FREE_NUMBER } from '../../../settings/settings';
import Button from '../../Shared/Button/Button';
import If from '../../Shared/If/If';
import Phone from '../../Shared/Phone/Phone';
import TextInput from '../../Shared/TextInput/TextInput';
import TRP from '../../Shared/TRP/TRP';
import PdfDisclosure from 'src/assets/docs/AgreementforElectronicFundsTransferServices.pdf';
const PATTERN_NUMBERS = /[0-9]/;
const PATTERN_ALPHA = /[a-zA-Z\s]/;
const PATTERN_NAME_SUFFIX = /[a-zA-Z\s.]/;

export class ManualEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNameField: this.hasJointOwner(props),
    };
    this.hasJointOwner = this.hasJointOwner.bind(this);
    this.handlePrevious = this.handlePrevious.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.toggleShowNameField = this.toggleShowNameField.bind(this);
  }

  componentDidMount() {
    const {
      actions: { resetEverify, updateManualBankOwner },
      dispatchPageLoad,
      personalInformation: {
        data: { firstName, lastName },
      },
      setUserPath,
      setBankProgress,
      eVerification: { attempts: everifyAttempts },
    } = this.props;

    resetEverify();
    setUserPath(PATH_MANUAL);
    dispatchPageLoad('Manual Bank Account Details');
    updateManualBankOwner(`${firstName} ${lastName}`);
    if (everifyAttempts > 2) {
      setBankProgress(STEP_BANK_FAILURE);
    }
  }

  toggleShowNameField() {
    const { actions } = this.props;
    this.setState({
      showNameField: !this.state.showNameField,
    });
    actions.updateManualBankJointOwnerFirstName('');
    actions.updateManualBankJointOwnerLastName('');
    actions.updateManualBankJointOwnerSuffix('');
  }

  hasJointOwner() {
    const {
      manualBankJointOwnerFirstName,
      manualBankJointOwnerLastName,
      manualBankJointOwnerSuffix,
    } = this.props;
    return (
      !!manualBankJointOwnerFirstName ||
      !!manualBankJointOwnerLastName ||
      !!manualBankJointOwnerSuffix
    );
  }

  onSubmit() {
    const { setBankProgress } = this.props;
    setBankProgress(STEP_EVERIFY);
  }

  handlePrevious() {
    const { dispatchPageLoad, setBankProgress } = this.props;
    dispatchPageLoad('Add New Bank Landing Page');
    setBankProgress(STEP_LANDING);
  }

  render() {
    const {
      actions: {
        updateManualBankAccountNumber,
        updateManualBankAccountType,
        updateManualBankAgreementConsent,
        updateManualBankJointOwnerFirstName,
        updateManualBankJointOwnerLastName,
        updateManualBankJointOwnerSuffix,
        updateManualBankRoutingNumber,
        updateManualBankSimulationMode,
        incrementEverifyAttempts,
        validateRoutingNumber,
        resetRoutingNumberValidation,
      },
      isSalesforceRep,
      customerWebViewEnabled,
      eVerification: {
        manualBankAccountNumber,
        manualBankAccountNumberError,
        manualBankAccountType,
        manualBankAccountTypeError,
        manualBankAgreementConsent,
        manualBankAgreementConsentError,
        manualBankJointOwnerFirstName,
        manualBankJointOwnerLastName,
        manualBankJointOwnerSuffix,
        manualBankReady,
        manualBankRoutingNumber,
        manualBankRoutingNumberError,
        manualBankSimulationMode,
        routingValidationLoading,
        routingValidationLoaded,
        routingValid,
      },
      isEnteredBankLapsed,
      personalInformation: {
        data: { firstName, lastName },
      },
      handleClose,
      setBankProgress,
    } = this.props;
    const { showNameField } = this.state;
    if (
      manualBankRoutingNumber?.length === 9 &&
      !routingValidationLoading &&
      !routingValidationLoaded
    ) {
      validateRoutingNumber(manualBankRoutingNumber);
    } else if (manualBankRoutingNumber?.length < 9 && routingValidationLoaded) {
      resetRoutingNumberValidation();
    }
    return (
      <div className="manual-entry">
        <form>
          <div className="manual-entry-modal-heading">
            Enter your bank account details
          </div>
          <div className="manual-entry-account-info-subhead">
            After you successfully link your bank account, you will be able to
            make a initial contribution immediately. The bank will need to be
            fully verified to perform additional contributions and/or
            redemptions.
            <br></br>
            <br></br>
            Your bank account will stay linked to speed up future transactions.
            You can unlink it at any time.
          </div>
          <div className="manual-entry-name-label">
            Name on the Bank Account
          </div>
          <div className="manual-entry-owner-name">
            <span className="blocked_data text-nowrap">
              {firstName} {lastName}
            </span>
            <If test={!showNameField}>
              <a
                className="manual-entry-add-name-link"
                onClick={this.toggleShowNameField}
              >
                + Add another name
              </a>
            </If>
          </div>
          <If test={showNameField}>
            <div className="manual-entry-joint-owner-container">
              <div className="manual-entry-joint-owner-title">
                Joint Owner{' '}
                <span className="manual-entry-joint-owner-optional">
                  (optional)
                </span>
                <If test={showNameField}>
                  <a
                    className="manual-entry-add-name-link remove-joint-owner-link"
                    onClick={this.toggleShowNameField}
                  >
                    <span className="manual-entry-joint-owner-optional-minus-sign">
                      -
                    </span>{' '}
                    Remove Joint Owner
                  </a>
                </If>
              </div>
              <label className="manual-entry-joint-owner-first">
                First name
                <TextInput
                  ariaLabel="Joint Owner First Name"
                  charPattern={PATTERN_ALPHA}
                  defaultValue={manualBankJointOwnerFirstName}
                  id="manual-bank-joint-owner-first-name"
                  onChange={updateManualBankJointOwnerFirstName}
                  //placeholder="Enter First Name"
                  tabIndex="2"
                />
              </label>
              <label className="manual-entry-joint-owner-last">
                Last name
                <TextInput
                  ariaLabel="Joint Owner Last Name"
                  charPattern={PATTERN_ALPHA}
                  defaultValue={manualBankJointOwnerLastName}
                  id="manual-bank-joint-owner-last-name"
                  onChange={updateManualBankJointOwnerLastName}
                  //placeholder="Enter Last Name"
                  tabIndex="3"
                />
              </label>
              <label className="manual-entry-joint-owner-suffix">
                Suffix{' '}
                <span className="manual-entry-joint-owner-optional">
                  (optional)
                </span>
                <TextInput
                  ariaLabel="Joint Owner Suffix"
                  charPattern={PATTERN_NAME_SUFFIX}
                  defaultValue={manualBankJointOwnerSuffix}
                  id="manual-bank-joint-owner-suffix"
                  onChange={updateManualBankJointOwnerSuffix}
                  //placeholder="Enter Suffix"
                  tabIndex="4"
                />
              </label>
            </div>
          </If>
          <div className="manual-entry-account-info-header">
            Routing and Account Information
          </div>
          <div className="manual-entry-account-info-subhead">
            You can find this information through your bank or in the lower left
            hand corner of your check.
          </div>
          <div className="manual-entry-title">Type of Account:</div>
          <div className="manual-entry-account-type-container">
            <RadioButton
              ariaLabel="Checking"
              autoFocus
              checked={manualBankAccountType === 'CHECKING'}
              displayErrorMessage
              error={manualBankAccountTypeError}
              id="manual-checking"
              labelText="Checking"
              name="manualBankAccountType"
              onChange={() => updateManualBankAccountType('CHECKING')}
              tabIndex="4"
            />
            <RadioButton
              ariaLabel="Savings"
              checked={manualBankAccountType === 'SAVINGS'}
              displayErrorMessage
              error={manualBankAccountTypeError}
              id="manual-savings"
              labelText="Savings"
              name="manualBankAccountType"
              onChange={() => updateManualBankAccountType('SAVINGS')}
              tabIndex="4"
            />
          </div>
          <div className="row">
            <div className="manual-entry-input-container col-xs-12 col-sm-3">
              <label>Routing number</label>

              <TextInput
                ariaLabel="Routing Number"
                charPattern={PATTERN_NUMBERS}
                defaultValue={manualBankRoutingNumber}
                displayErrorMessage={
                  !(routingValidationLoading || routingValid)
                }
                displayValidationMessage={
                  !!(routingValidationLoading || routingValid)
                }
                validationMessage={manualBankRoutingNumberError}
                error={manualBankRoutingNumberError}
                disabled={routingValidationLoading}
                id="manualBankRoutingNumber"
                maxLength="9"
                onChange={updateManualBankRoutingNumber}
                placeholder="123456789"
                tabIndex="7"
              />
            </div>
            <div className="manual-entry-input-container col-xs-12 col-sm-9">
              <label>Account number</label>

              <TextInput
                ariaLabel="Account Number"
                charPattern={PATTERN_NUMBERS}
                defaultValue={manualBankAccountNumber}
                displayErrorMessage
                error={manualBankAccountNumberError}
                id="manualBankAccountNumber"
                onChange={updateManualBankAccountNumber}
                placeholder="0000123456789"
                tabIndex="8"
              />
            </div>
          </div>
          <If test={isEnteredBankLapsed}>
            <div className="manual-entry-error-bank">
              This bank was previously added to your accounts but bank
              verification was never completed. To add this bank to your <TRP />{' '}
              account, call <TRP /> at{' '}
              <Phone
                phoneNumber={TOLL_FREE_NUMBER}
                phoneStyleName="manual-entry-phone-number"
              />
              .
            </div>
          </If>
          <div className="manual-entry-agreement-container">
            <div className="manual-entry-agreement-checkbox">
              <Checkbox
                ariaLabel="Final agreement consent checkbox"
                checked={manualBankAgreementConsent}
                error={manualBankAgreementConsentError}
                id="checkbox_final_agreement"
                name="manualBankAgreementConsent"
                onClick={updateManualBankAgreementConsent}
                tabIndex="9"
              />
            </div>
            <div className="manual-entry-agreement-text">
              {!customerWebViewEnabled && isSalesforceRep ? (
                <span>The client agrees to the</span>
              ) : (
                <span>I agree to</span>
              )}{' '}
              <a
                id="eft-agreement-link"
                target="_blank"
                rel="noreferrer"
                href={PdfDisclosure}
              >
                Electronic Funds Transfer Service Agreement
              </a>{' '}
              as specified in the document.
            </div>
          </div>
          <div className="manual-entry-buttons-container e2e-eVerify-button">
            <div className="manual-entry-cancel-button" onClick={handleClose}>
              Cancel
            </div>
            <Button
              id="add-bank-manual-entry-continue-button"
              disabled={
                !manualBankReady ||
                isEnteredBankLapsed ||
                !routingValid ||
                customerWebViewEnabled
              }
              buttonType="primary"
              onClick={this.onSubmit}
            >
              Continue
            </Button>
          </div>
          {!settings.isProd && (
            <ManualEntryStageOptions
              manualBankSimulationMode={manualBankSimulationMode}
              updateManualBankSimulationMode={updateManualBankSimulationMode}
            />
          )}
          {window.location.hostname === 'localhost' && (
            <div>
              <Button onClick={() => setBankProgress(STEP_BANK_SUCCESS)}>
                Success
              </Button>
              <Button
                onClick={() => {
                  incrementEverifyAttempts();
                  setBankProgress(STEP_BANK_FAILURE);
                }}
              >
                Fail
              </Button>
            </div>
          )}
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isEnteredBankLapsed: getIsEnteredBankLapsed(state),
  };
};

export default compose(connect(mapStateToProps))(ManualEntry);
